export default "__VITE_ASSET__CgPZeyvX__$_?url__"